import { SUGGESTED_ROS_COMMISSION } from '@constants';

export const getEffectiveRestOfSiteCommission = (accountCommission) =>
    accountCommission?.restOfSite || SUGGESTED_ROS_COMMISSION;
